module.exports = __webpack_public_path__ + "img/Easy_Set_Up.668014fa.svg";